import { getAssignmentProgress } from "seneca-common/features/assignments/features/student-assignments/state";
import { useSelectorWithArgs } from "seneca-common/utils/hooks/selectors";

import ProgressBar from "features/classroom/common/ProgressBar";

type Props = { assignmentId: string };

export default function AssignmentProgressBar({ assignmentId }: Props) {
  const assignmentProgress = useSelectorWithArgs(
    getAssignmentProgress,
    assignmentId
  );

  return <ProgressBar progress={assignmentProgress} />;
}
